var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFj01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.25,0H.75c-.41,0-.75.34-.75.75v5.94c0,.41.34.75.75.75s.75-.34.75-.75V1.5h27v5.19c0,.41.34.75.75.75s.75-.34.75-.75V.75c0-.41-.34-.75-.75-.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.89,17.09l-3.02-4.38v7.57H0v-10.8h1.63l3.52,5,3.53-5h1.63v10.8h-1.87v-7.55l-3.05,4.36h-.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18.12,9.48h1.87v6.62c0,.65-.11,1.24-.32,1.78-.21.54-.51,1.01-.89,1.4-.38.39-.84.7-1.38.91-.54.22-1.13.33-1.78.33-.61,0-1.19-.1-1.72-.31-.53-.21-.99-.5-1.38-.88-.39-.38-.7-.84-.92-1.39s-.33-1.16-.33-1.83v-6.62h1.86v6.62c0,.38.05.74.16,1.06.11.33.27.62.48.86.21.25.47.44.78.58.31.14.67.21,1.07.21s.74-.07,1.05-.21c.31-.14.57-.33.78-.57.21-.24.37-.53.49-.85.11-.33.17-.68.17-1.06v-6.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.02,13.27l2.77-3.79h2.21l-3.81,5.15,3.81,5.65h-2.21l-2.77-4.27-2.46,4.27h-2.2l3.49-5.65-3.49-5.15h2.2l2.46,3.79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m29.25,30H.75c-.41,0-.75-.34-.75-.75v-5.94c0-.41.34-.75.75-.75s.75.34.75.75v5.19h27v-5.19c0-.41.34-.75.75-.75s.75.34.75.75v5.94c0,.41-.34.75-.75.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFj01);
export default __webpack_public_path__ + "static/media/FJ01.7371be5c1658ee68947002b0e1506342.svg";
export { ForwardRef as ReactComponent };